import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

const connectPaymentGateway = (data, sellerId, gateway, token) => {
  const url = `${apiUrl}/sellers/${sellerId}/connect-payment-gateway/${gateway}`;

  return request(url, token, {
    body: JSON.stringify(data),
    method: 'POST',
  });
};

export { connectPaymentGateway };
